import { Component, Input } from '@angular/core';
import { User } from '../../../core/models/user.model';
import { UserStatus } from '../../../core/enums/user-status.enum';
import { DatePipe } from '@angular/common';
import { UserStatusPipe } from '../../pipes/user-status.pipe';

@Component({
    selector: 'app-user-status',
    templateUrl: './user-status.component.html',
    styleUrls: ['./user-status.component.scss'],
    imports: [DatePipe, UserStatusPipe]
})
export class UserStatusComponent {
  userStatuses = UserStatus;

  @Input() user: User;

  constructor() {}
}
